import produce from 'immer';

import { handleActions } from 'redux-actions';

import { mapFileActions } from 'commons/store/mapFile';

const initialstate = {
  tree: {},
};

export default handleActions(
  {
    [mapFileActions.restoreState]: (_, { payload }) => payload,

    [mapFileActions.clearMapFiles]: () => initialstate,

    [mapFileActions.updateTree]: produce((draft, { payload }) => {
      draft.tree = payload;
    }),
  },
  initialstate
);
